<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
  <path d="M12.6 10h-0.8L9 13 6.2 10H5.4C4.1 10 3 11.1 3 12.4V15h12v-2.6C15 11.1 13.9 10 12.6 10z" fill="#231F20" />
  <path
    d=" M9 9.5c1 0 1.9-0.5 2.5-1.3C11.8 7.7 12 7.1 12 6.5V5c0-1.7-1.3-3-3-3S6 3.3 6 5v1.5c0 0.6 0.2 1.2 0.5 1.7C7.1 9 8
    9.5 9 9.5z" fill="#231F20" />
</svg>
